

const dashboardRoutes = [
{
    path: '',
    name: 'admin-root',
    component: () => import('../views/Dashboard.vue'),
    meta: {
        title: 'Banner Insite - Dashboard Admin',
        permissions: ["system_admin", "client_admin",'admin','manager','user']
    },
    sensitive: true,
    strict: true
},    
{
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
        title: 'Banner Insite - Dashboard Admin',
        permissions: ['system_admin', "client_admin",'admin','manager','user']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-client',
    name: 'manage-client',
    component: () => import('../views/systemAdmin/ManageClient.vue'),
    meta: {
        title: 'Banner Insite - Manage Clients',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-user',
    name: 'manage-user',
    component: () => import('../views/systemAdmin/ManageUser.vue'),
    meta: {
        title: 'Banner Insite - Manage Users',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-offerlogix',
    name: 'manage-offerlogix',
    component: () => import('../views/systemAdmin/ManageOfferlogix.vue'),
    meta: {
        title: 'Banner Insite - Manage Offerlogix',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'generate-template',
    name: 'generate-template',
    component: () => import('../views/systemAdmin/GenerateTemplate.vue'),
    meta: {
        title: 'Banner Insite - Generate Template',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-templates',
    name: 'manage-templates',
    component: () => import('../views/systemAdmin/ManageTemplate.vue'),
    meta: {
        title: 'Banner Insite - Manage Templates',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-image',
    name: 'manage-image',
    component: () => import('../views/systemAdmin/ManageImage.vue'),
    meta: {
        title: 'Banner Insite - Manage Images',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-site',
    name: 'manage-site',
    component: () => import('../views/systemAdmin/ManageSite.vue'),
    meta: {
        title: 'Banner Insite - Manage Sites',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'configure-assets',
    name: 'configure-assets',
    component: () => import('../views/systemAdmin/ConfigureAssets.vue'),
    meta: {
        title: 'Banner Insite - Configure Assets',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},


{
    path: 'manage-dimensions',
    name: 'manage-dimensions',
    component: () => import('../views/systemAdmin/ManageDimensions.vue'),
    meta: {
        title: 'Banner Insite - Manage Dimensions',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-data-sets',
    name: 'manage-data-sets',
    component: () => import('../views/systemAdmin/ManageDataSets.vue'),
    meta: {
        title: 'Banner Insite - Manage Data Sets',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-data-set-types',
    name: 'manage-data-set-types',
    component: () => import('../views/systemAdmin/ManageDataSetTypes.vue'),
    meta: {
        title: 'Banner Insite - Manage Data Set Types',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-data-set-configuration',
    name: 'manage-data-set-configuration',
    component: () => import('../views/systemAdmin/ManageDataSetsConfig.vue'),
    meta: {
        title: 'Banner Insite - Manage Data Set Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

// {
//     path: 'manage-data-set-site-configuration',
//     name: 'manage-data-set-site-configuration',
//     component: () => import('../views/systemAdmin/ManageDataSetSiteConfig.vue'),
//     meta: {
//         title: 'Banner Insite - Manage Data Set Site Configuration',
//         permissions: ['system_admin']
//     },
//     sensitive: true,
//     strict: true
// },
{
    path: 'manage-static-data-set-configuration',
    name: 'manage-static-data-set-configuration',
    component: () => import('../views/systemAdmin/ManageStaticDataSetsConfig.vue'),
    meta: {
        title: 'Banner Insite - Manage Static Data Set Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-themes',
    name: 'manage-themes',
    component: () => import('../views/systemAdmin/ManageTheme.vue'),
    meta: {
        title: 'Banner Insite - Manage Themes',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-theme-defaults',
    name: 'manage-theme-defaults',
    component: () => import('../views/systemAdmin/ManageThemeDefaults.vue'),
    meta: {
        title: 'Banner Insite - Manage Theme Defaults',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-css-variables',
    name: 'manage-css-variables',
    component: () => import('../views/systemAdmin/ManageCssVariables.vue'),
    meta: {
        title: 'Banner Insite - Css Variables',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-font-faces',
    name: 'manage-font-faces',
    component: () => import('../views/systemAdmin/ManageFontFaces.vue'),
    meta: {
        title: 'Banner Insite - Font Faces',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'configure-service-special-types',
    name: 'configure-service-special-types',
    component: () => import('../views/systemAdmin/ManageServiceSpecialsTypes.vue'),
    meta: {
        title: 'Banner Insite - Service Special Types',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'configure-service-specials',
    name: 'configure-service-specials',
    component: () => import('../views/systemAdmin/ManageServiceSpecialsConfig.vue'),
    meta: {
        title: 'Banner Insite - Service Special Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-data-set-configuration_v3',
    name: 'manage-data-set-configuration_v3',
    component: () => import('../views/systemAdmin/ManageDataSetsConfigV3.vue'),
    meta: {
        title: 'Banner Insite - Manage Data Set Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-static-data-set-configuration_v3',
    name: 'manage-static-data-set-configuration_v3',
    component: () => import('../views/systemAdmin/ManageStaticDataSetsConfigV3.vue'),
    meta: {
        title: 'Banner Insite - Manage Static Data Set Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-data-set-configuration_temp',
    name: 'manage-data-set-configuration_temp',
    component: () => import('../views/systemAdmin/ManageDataSetsConfigTemp.vue'),
    meta: {
        title: 'Banner Insite - Manage Data Set Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-static-data-set-configuration_temp',
    name: 'manage-static-data-set-configuration_temp',
    component: () => import('../views/systemAdmin/ManageStaticDataSetsConfigTemp.vue'),
    meta: {
        title: 'Banner Insite - Manage Static Data Set Configuration',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'manage-default-disclaimers_v3',
    name: 'manage-default-disclaimers_v3',
    component: () => import('../views/systemAdmin/v3/textDefaults/DisclaimerDefaults.vue'),
    meta: {
        title: 'Banner Insite - Admin Manage Default Disclaimers',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

// {
//     path: 'manage-default-combined-disclaimers_v3',
//     name: 'manage-default-combined-disclaimers_v3',
//     component: () => import('../views/systemAdmin/v3/textDefaults/CombinedDisclaimersDefaults.vue'),
//     meta: {
//         title: 'Banner Insite - Admin Manage Default Combined Disclaimers',
//         permissions: ['system_admin']
//     },
//     sensitive: true,
//     strict: true
// },

{
    path: 'imagin-studios',
    name: 'imagin-studios',
    component: () => import('../views/systemAdmin/ImaginImages.vue'),
    meta: {
        title: 'Banner Insite - Imagin Studios',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

{
    path: 'admin-manage-image-cropper',
    name: 'admin-manage-image-cropper',
    component: () => import('../views/systemAdmin/ImageCropper.vue'),
    meta: {
        title: 'Banner Insite - Image Cropper',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},

//version 4
{
    path: 'manage-theme-defaults-v4',
    name: 'manage-theme-defaults-v4',
    component: () => import('../views/v4/Theme/ThemeDefaults.vue'),
    meta: {
        title: 'Banner Insite - Manage Theme Defaults',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-templates-v4',
    name: 'manage-templates-v4',
    component: () => import('../views/v4/Templates/BannerTypesTemplates.vue'),
    meta: {
        title: 'Banner Insite - Manage Templates V4',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},
{
    path: 'manage-themes-v4',
    name: 'manage-themes-v4',
    component: () => import('../views/v4/Theme/ManageThemeV4.vue'),
    meta: {
        title: 'Banner Insite - Manage Themes',
        permissions: ['system_admin']
    },
    sensitive: true,
    strict: true
},





// {
//     path: 'admin-manage-defaults-assets-client',
//     name: 'admin-manage-defaults-assets-client',
//     component: () => import('../views/clientAdmin/ManageDefaultsAssetsClient.vue'),
//     meta: {
//         title: 'Banner Insite - Manage Defaults & Assets',
//         permissions: ["system_admin"]
//     },
//     sensitive: true,
//     strict: true
// },






// {
//     path: 'manage-client',
//     name: 'manage-client',
//     component: () => import('../views/systemAdmin/ManageClient.vue'),
//     meta: {
//         title: 'Banner Insite - Manage Client',
//     }
// },
// {
//     path: 'test',
//     name: 'test',
//     component: () => import('../views/systemAdmin/Test.vue'),
//     meta: {
//         title: 'Banner Insite - Test',
        
//     }
// },

    
]

export default dashboardRoutes